import React from 'react';
import Icon from '../../icon/Icon';

import './FormItem.scss';

interface Props {
  text?: string;
  description?: string;
  infoMsg?: string;
  required?: boolean;
}

const FormItem: React.FC<Props> = ({ text, description, infoMsg, children, required = '' }) => {
  return (
    <div className="form-item">
      <div className="row">
        <div className="col-3">
          {text && <div className="form-item__text">{`${text} ${required && '*'}`}</div>}
          {description && <div className="form-item__description">{description}</div>}
          {infoMsg && (
            <div className="form-item__info">
              <Icon className="form-item__info-icon" icon="info" size="small" svg />
              {infoMsg}
            </div>
          )}
        </div>
        <div className="col-4">
          <div className="form-item__content">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default FormItem;
